







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import PdfTranslator from '@/components/auto-translation/pdf-translator.vue';

@Component({
  components: {
    PageTitle,
    PdfTranslator
  }
})
export default class PdfTranslatorView extends Vue {}
